// Tailwind className concatenator. Pure utility, no data dependencies.
// Postgres mapping and integration hook: not applicable.
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
